import React from 'react';
import TableCell from '@mui/material/TableCell';

const HeaderColumnCell = props => {
    const { children, ...restProps } = props;
    return (
        <TableCell className='table__header-column' {...restProps}>
            <div className='table__header-column__container'>{children}</div>
        </TableCell>
    );
};

export default HeaderColumnCell;
